export default "__VITE_ASSET__i314YTID__"